import React from "react";
import ServicePageLayout from "./ServicePageLayout";

const StaffingServices = () => {
  return (
    <ServicePageLayout
      imageTitle={
        [
          "AI-Integrated Staffing Solutions for Smarter, Faster Hiring "
        ]
      }
      heroImage="/staffing-service.png"
      sectionTitle="Our AI-Powered Staffing Services "
      description={[
        "Our advanced AI tools and automation systems empower both Indian and US staffing processes, optimizing everything from resume parsing to predictive analytics for candidate success. With our tech-driven approach, you don’t just fill roles—you build smarter teams."

      ]}
      benefitsTitle=""
      benefits={[
        "💻 Information Technology (IT) ",
        "🏥 Healthcare & Pharma ",
        "🛒 Retail & E-commerce",
        "🏭 Manufacturing & Engineering ",
        "📚 Education & Training",
        " BFSI & Corporates ",
      ]}
      secondaryImage="/staffing-service-section.png"
      servicesTitle="Why Choose us"
      services={[
        {
          title: "Tech-Driven Efficiency",
          desc: "Cut hiring times by over 50% with automation and intelligent systems.",
        },
        {
          title: " Better Candidate Fit",
          desc: "Machine learning ensures high-quality matches based on behavior, skills, and potential.",
        },
        {
          title: "Data-Backed Hiring Decisions",
          desc: " Make confident decisions with predictive analytics and actionable insights.",
        },

        {
          title: "Scalable & Global",
          desc: " Whether you need 1 or 1000 employees, our AI systems scale with you - across regions and time zones.",
        },
        {
          title: " Human + AI Expertise",
          desc: "Our recruiters work with AI tools, not against them - combining tech precision with human judgment.",
        }
      ]}
    />
  );
};

export default StaffingServices;
